import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./EnergyServicesHomeStyles";
import Header from "../components/Header";
import PageTitle from "../components/PageTitle";
import AssistedLivingNavigation from "../components/AssistedLivingNavigation";
import Loading from "../components/Loading";
import AlertCounter from "../components/AlertCounter";
import AlertBreakdown from "../components/AlertBreakdown";
import AlertTitles from "../components/AlertTitles";
import AlertItem from "../components/AlertItem";
import AlertEnd from "../components/AlertEnd";
import PopupWrapper from "../components/PopupWrapper";
import { alertsActions } from "../_actions";
import { connect } from "react-redux";

class AssistedLivingHome extends Component {
  constructor(props) {
    super(props);
    const unix = Math.round(+new Date() / 1000);

    this.props.dispatch(
      alertsActions.getDetail(props.authentication.user.dependant_user_id, unix)
    );
  }

  render() {
    const { fetchingDetail, detail } = this.props.alerts;

    const isDemoUser = JSON.parse(localStorage.getItem("is_demo_user")) || false;

    return (
      <div>
        <Header
          title={"Parent's Home"}
          backTitle={"Dashboard"}
          isAssistedLiving={true}
          backHref={"/"}
        />
        <PageTitle title={"Alerts"} />
        <AssistedLivingNavigation {...this.props.location} />
        <div className={css(styles.container)}>
          <PopupWrapper />
          {fetchingDetail && <Loading />}
          {!fetchingDetail && (
            <div>
              <AlertCounter {...detail} />
              <AlertBreakdown {...detail} />
              {detail && detail.length ? <AlertTitles /> : null}
              <div>
                {detail && detail.length
                  ? detail.map((item, i) => {
                      return (
                        <AlertItem
                          key={i}
                          ref={i}
                          {...item}
                          isDemoUser={isDemoUser}
                          user={this.props.authentication.user}
                          dispatch={this.props.dispatch}
                        />
                      );
                    })
                  : null}
              </div>
              <AlertEnd {...detail} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { fetchingDetail } = state.alerts;
  const alerts = state.alerts;
  const authentication = state.authentication;
  return {
    fetchingDetail,
    alerts,
    authentication
  };
}

export default connect(mapStateToProps)(AssistedLivingHome);
